import { formatData, checkErrorData } from "./utils";

export function fetchProducts(){
    console.log("FIRED ACTION FETCH PRODUCTS" )
    return async function(dispatch){
        dispatch({
            type: "FETCH_PRODUCTS_START",
            payload: ""
            
        })
        try {
            const response = await fetch('/stocks/getList',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page:"products",
                }),
                credentials: 'same-origin',
            }); 
            
            const prodsList = await response.json()
            console.log(prodsList)

            if(!prodsList.error){ // no errors
                
                dispatch(getProducts(formatData(prodsList.reverse()) ))
                dispatch({ type: "FETCH_PRODUCTS_FULFILLED", payload:"" })
                console.log(" products fetched")
                
                // dispatch(fetchStocks())
            
            } else {
                dispatch({
                    type: "FETCH_PRODUCTS_ERROR",
                    payload: prodsList.error.message
                })
            }
            
        } catch (err) {
            dispatch({
                type: "FETCH_PRODUCTS_ERROR",
                payload: err
                
            })
        }
    }
}
export function createProductOld(newProd){
    // console.log("FIRED ACTION CREATE PRODUCT", newProduct)
    return async function(dispatch){
        dispatch({
            type: "CREATE_PRODUCT_START",
            payload: ""
            
        })
        try {
            try {
                for(let i = 0; i < newProd.photos.length; i++){
                    let photo = newProd.photos[i]
                    console.log("[INFO] PRODUCTS submit upload photos ", i, photo, photo.file);

                    const resPhotos = await fetch('/stocks/uploadPhotos', {
                        method: 'POST',
                        headers: { 
                            'Content-Type': 'application/json',
                            //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                        },
                        body:JSON.stringify({file : photo}),
                        credentials: 'same-origin',
                    }); 

                    const bodyRes = await resPhotos.json()
                    console.log("[INFO] PRODUCTS submit upload photos res", bodyRes)
                    if (bodyRes.path) {
                        newProd.photos[i] = {filename:bodyRes.path}
                    } 
                    else {
                        console.log("[ERROR] while uploading photo ", i+1);
                        dispatch({
                            type: "CREATE_PRODUCT_ERROR",
                            payload: bodyRes.error.message
                        })
                        newProd.photos[i] = {filename:""}
                    }
                }
                
            } catch (error) {
                console.log("[ERROR] SUBMIT PHOTO UPLOAD", error);
                dispatch({ type: "CREATE_PRODUCT_ERROR", payload: error })
            }
            const response = await fetch('/stocks/addData',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page:"products",
                    data:newProd
                }),
                credentials: 'same-origin',
            }); 
            
            const createdProduct = await response.json()
            console.log(createdProduct)// createdProduct returns new object created

            if(createdProduct.id){ // no errors, return new Object
                createdProduct.src = [] // array to save photos src URI
                dispatch({
                    type: "NEW_PRODUCT",
                    payload: createdProduct
                    
                })
                dispatch({ type: "CREATE_PRODUCT_FULFILLED", payload:"" })
                console.log("Product created")
            } else {
                dispatch({
                    type: "CREATE_PRODUCT_ERROR",
                    payload: createdProduct.error.message
                })
            }
            
        } catch (err) {
            console.log("[ERROR] SUBMIT PRODUCT ", err);
            dispatch({ type: "CREATE_PRODUCT_ERROR", payload: err })
        }
    }
}
// Reconnait le refus « ce produit existe déjà dans le catalogue » et rend la
// fiche trouvée.
//
// Le storehouse la nomme pour que l'écran propose de l'adopter : un refus qui
// ne propose rien pousse l'utilisateur à changer un caractère pour passer, et
// fabrique le doublon qu'il prétendait empêcher.
//
// Deux formes sont acceptées, celle du storehouse et celle qu'un relais
// Express pourrait encore envelopper dans un champ error. La profondeur est
// bornée : un corps inattendu ne doit pas faire boucler l'interface.
function lireRefusDoublon(corps, profondeur) {
    const niveau = profondeur || 0
    if (!corps || typeof corps !== "object" || niveau > 3) {
        return null
    }
    if (corps.error === "produit_existant" && corps.produit) {
        return corps.produit
    }
    if (corps.error && typeof corps.error === "object") {
        return lireRefusDoublon(corps.error, niveau + 1)
    }
    return null
}

// Le corps d'erreur arrive en texte, et n'est pas toujours du JSON : une page
// d'erreur HTML passe par le même chemin.
function lireRefusDoublonTexte(texte) {
    if (!texte) {
        return null
    }
    try {
        return lireRefusDoublon(JSON.parse(texte))
    } catch (parseError) {
        return null
    }
}

/**
 * Crée un produit.
 *
 * @returns {object|undefined} { produit_existant } quand le serveur a refusé
 *          parce que le libellé existe déjà dans le catalogue global, la fiche
 *          trouvée étant nommée pour que l'écran propose de l'adopter. Rien
 *          dans les autres cas : le succès comme l'échec ordinaire se lisent,
 *          comme avant, dans products.error du store.
 */
export function createProduct(newProd){
    // console.log("FIRED ACTION CREATE PRODUCT", newProduct)
    return async function(dispatch){
        dispatch({
            type: "CREATE_PRODUCT_START",
            payload: ""
            
        })
        try {
            const response = await fetch('/stocks/addData',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page:"products",
                    data:newProd
                }),
                credentials: 'same-origin',
            }); 
            
            // Check if response is successful
            if (!response.ok) {
                const errorText = await response.text();
                let errorMessage = "Erreur lors de la création du produit";

                // Le refus par doublon est rendu à l'appelant, qui a de quoi
                // proposer l'adoption. Le store porte quand même un message :
                // le formulaire le relit, et un état d'erreur laissé vide
                // ferait passer le refus pour une création réussie.
                const doublon = lireRefusDoublonTexte(errorText)
                if (doublon) {
                    dispatch({
                        type: "CREATE_PRODUCT_ERROR",
                        payload: "Ce produit existe déjà dans le catalogue : " + (doublon.name || ""),
                    })
                    return { produit_existant: doublon }
                }

                if (response.status === 409) {
                    // Conflict - duplicate product name
                    errorMessage = errorText || "Un produit avec ce nom existe déjà dans votre compte";
                } else if (response.status === 404) {
                    errorMessage = errorText || "Erreur lors de la création du produit";
                } else {
                    errorMessage = errorText || `Erreur ${response.status}: ${response.statusText}`;
                }
                
                dispatch({
                    type: "CREATE_PRODUCT_ERROR",
                    payload: errorMessage
                })
                return;
            }
            
            const createdProduct = await response.json()
            console.log(createdProduct)// createdProduct returns new object created

            if(createdProduct.id){ // no errors, return new Object
                createdProduct.src = [] // array to save photos src URI
                dispatch({
                    type: "NEW_PRODUCT",
                    payload: createdProduct
                    
                })
                dispatch({ type: "CREATE_PRODUCT_FULFILLED", payload:"" })
                console.log("Product created")
            } else {
                // Le refus par doublon peut aussi arriver ici : le contrat
                // fixe le corps de la réponse, pas son statut, et un refus
                // annoncé en 200 ne doit pas se perdre en message illisible.
                const doublon = lireRefusDoublon(createdProduct)
                if (doublon) {
                    dispatch({
                        type: "CREATE_PRODUCT_ERROR",
                        payload: "Ce produit existe déjà dans le catalogue : " + (doublon.name || ""),
                    })
                    return { produit_existant: doublon }
                }

                dispatch({
                    type: "CREATE_PRODUCT_ERROR",
                    payload: createdProduct.error?.message || "Erreur lors de la création du produit"
                })
            }
            
        } catch (err) {
            console.log("[ERROR] SUBMIT PRODUCT ", err);
            dispatch({ type: "CREATE_PRODUCT_ERROR", payload: err.message || err })
        }
    }
}
export function updateProduct(data) {
    return async function(dispatch){
        try {
            dispatch({ type: "UPDATE_PRODUCT_START", payload: "" })

            console.log("update Product START")
            const response = await fetch('/stocks/single',{
                method:'PUT',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify(data),
                credentials: 'same-origin',
            }); 
            
            const updatedProduct = await response.json()
            
            console.log({updatedProduct});

            if(checkErrorData(updatedProduct, "UPDATE_PRODUCT_ERROR", dispatch ) ) {
                dispatch({
                    type: "UPDATE_PRODUCT",
                    payload: data
                })
                dispatch({ type: "UPDATE_PRODUCT_FULFILLED", payload: "" })
            }

        } catch(err) {
            console.log("[ERROR] update product ", err);
            dispatch({
                type: "UPDATE_PRODUCT_ERROR",
                payload: err
                
            })
        }
    }
}
// Ajoute ou remplace une seule fiche dans le store, sans toucher aux autres.
//
// getProducts remplace la carte entière et suppose qu'on vient de relire tout
// le compte : l'adoption d'un produit du catalogue, elle, ne rapporte qu'une
// fiche, et rien ne justifie de recharger le reste pour l'y poser.
export function setProduct(product){
    return {
        type: "NEW_PRODUCT",
        payload: product
    }
}
export function getProducts(products){
    // console.log("FIRED ACTION GET PRODUCT", products)
    return {
        type: "GET_PRODS",
        payload: products
        
    }
}
export function setPhotoProd(prodID,URI){
    return {
        type: "SET_MAIN_PHOTO",
        payload: {prodID, URI}
        
    }
}

export function getAllPhotos() {
    return async function(dispatch){        
        let response = await fetch("/stocks/getAllPhotos",{
            method:'GET',
            headers: { 
                'Content-Type': 'application/json',
                //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
            },
            credentials: 'same-origin',
        })
        let res = await response.json() // {key: "product_id", value: "URI"}
        if(res.photoList){
            dispatch({ type: "SET_ALL_PHOTOS", payload: res.photoList })
            dispatch({ type: "PRODUCT_PHOTOS_FULFILLED", payload: "" })
        } else {
            dispatch({ type: "PRODUCT_PHOTOS_ERROR", payload: res.error.message })
        }
        
    }
}
export function getPhotoProd(prodID,filename, main = false) {
    return async function(dispatch){        
        let response = await fetch("/stocks/getPhotos",{
            method:'POST',
            headers: { 
                'Content-Type': 'application/json',
                //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
            },
            body:JSON.stringify({
                path:filename
            }),
            credentials: 'same-origin',
        })
        let image = await response.json()
        if(main){
            dispatch(setPhotoProd(prodID, image.uri))
        } else {
            dispatch({
                type: "SET_PHOTOS",
                payload: {prodID, URI:image.uri}
                
            })
        }
    }
}
export function addPhotosProduct(files){
    return async function(dispatch){
        dispatch({
            type: "ADD_PHOTOS_PRODUCT_START",
            payload: ""
            
        })
        try {
            const response = await fetch('/stocks/addData',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page:"products/add/files",
                    data:files
                }),
                credentials: 'same-origin',
            }); 
            
            const updatedProduct = await response.json()
            console.log(updatedProduct)// updatedProduct returns new object created

            if(updatedProduct.id){ // no errors, return new Object
                dispatch({
                    type: "UPDATE_PRODUCT",
                    payload: updatedProduct
                    
                })
                dispatch({ type: "ADD_PHOTOS_PRODUCT_FULFILLED", payload:"" })
                console.log("Product updated")

            } else {
                dispatch({
                    type: "ADD_PHOTOS_PRODUCT_ERROR",
                    payload: updatedProduct.error.message
                    
                })
                
            }
            
        } catch (err) {
            console.log("[ERROR] files PRODUCT ", err);
            dispatch({
                type: "ADD_PHOTOS_PRODUCT_ERROR",
                payload: err
                
            })
        }
    }
}
export function updatePhotosProduct(files){
    return async function(dispatch){
        dispatch({
            type: "ADD_PHOTOS_PRODUCT_START",
            payload: ""
            
        })
        try {
            const response = await fetch('/stocks/addData',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page:"products/update/files",
                    data:files
                }),
                credentials: 'same-origin',
            }); 
            
            const updatedProduct = await response.json()
            console.log(updatedProduct)// updatedProduct returns new object created

            if(updatedProduct.id){ // no errors, return new Object
                dispatch({
                    type: "UPDATE_PRODUCT",
                    payload: updatedProduct
                    
                })
                dispatch({ type: "ADD_PHOTOS_PRODUCT_FULFILLED", payload:"" })
                console.log("Product updated")
                // Synchro automatique PrestaShop : started | skipped_empty | none (storehouse)
                return updatedProduct.ecom_sync

            } else {
                dispatch({
                    type: "ADD_PHOTOS_PRODUCT_ERROR",
                    payload: updatedProduct.error.message
                    
                })
                
            }
            
        } catch (err) {
            console.log("[ERROR] files PRODUCT ", err);
            dispatch({
                type: "ADD_PHOTOS_PRODUCT_ERROR",
                payload: err
                
            })
        }
    }
}

export function resetProductState(){
    return function(dispatch){
        dispatch({
            type: "RESET_PRODUCT_STATE",
            payload: ""
        })
    }
}

// Ajoute au store une photo que le serveur vient d'enregistrer sur la fiche (image générée par
// IA), sans recharger tout le catalogue.
export function addProductPhotoLocal(product, photo){
    return function(dispatch){
        if (!product || !product.id || !photo || !photo.filename) return
        dispatch({
            type: "UPDATE_PRODUCT",
            payload: { ...product, photos: [...(product.photos || []), photo] }
        })
    }
}

/**
 * Recharge la liste des produits sans passer par FETCH_PRODUCTS_START/FULFILLED (pas de clignotement
 * de l'écran) : après une synchro des photos PrestaShop, des images ont pu être importées ou retirées
 * de la fiche. Un échec est silencieux : la fiche garde son état actuel.
 */
export function refreshProductsSilently(){
    return async function(dispatch){
        try {
            const response = await fetch('/stocks/getList',{
                method:'POST',
                headers: { 'Content-Type': 'application/json' },
                body:JSON.stringify({ page:"products" }),
                credentials: 'same-origin',
            });
            const list = await response.json()
            if (response.ok && Array.isArray(list)) {
                dispatch(getProducts(formatData(list.reverse())))
            }
        } catch (err) {
            console.log("[ERROR] refreshProductsSilently", err);
        }
    }
}
